import {onReady} from "../../../../modules/vegas/js/util";

import 'vgsidebar';

function init() {
	const sidebarMainNav = document.getElementById('vg-nav-sidebar')

	if (sidebarMainNav) {
		sidebarMainNav.addEventListener('vg.sidebar.show', function () {
			document.body.classList.add('sidebar-nav-open');

			let hamburger = document.querySelector('#hamburger-nav');
			if (hamburger) hamburger.classList.add('is-active');
		});

		sidebarMainNav.addEventListener('vg.sidebar.hide', function () {
			document.body.classList.remove('sidebar-nav-open');

			let hamburger = document.querySelector('#hamburger-nav');
			if (hamburger) hamburger.classList.remove('is-active');
		});
	}
}

onReady(init);
typeof onTurboRender !== 'undefined' && onTurboRender(init);
